'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _combineStyles = require('../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var container = function container() {
  return _styles2.default.container;
};

var overlay = function overlay(open) {
  var style = _styles2.default.overlay;

  if (open) {
    style = (0, _combineStyles2.default)(style, { opacity: 1, pointerEvents: 'auto', left: 0 });
  }

  return style;
};

var root = function root(open, position, overrideStyle) {
  var style = _styles2.default.root;

  if (position === 'right') {
    style = (0, _combineStyles2.default)(style, { left: 'initial', right: 0, transform: 'translateX(256px)' });
  }

  if (open) {
    style = (0, _combineStyles2.default)(style, { transform: 'none' });
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

var contentContainer = function contentContainer(header, footer, overrideStyle) {
  var style = _styles2.default.contentContainer;

  if (header) {
    style = (0, _combineStyles2.default)(style, { maxHeight: 'calc(100% - 48px)' });
  }

  if (footer) {
    style = (0, _combineStyles2.default)(style, { maxHeight: 'calc(100% - 35px)' });
  }

  if (header && footer) {
    style = (0, _combineStyles2.default)(style, { maxHeight: 'calc(100% - 83px)' });
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

var header = function header() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colors2.default.theme;
  var icon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var overrideStyle = arguments[2];

  var style = (0, _combineStyles2.default)(_styles2.default.header, { color: color });

  if (icon) {
    style = (0, _combineStyles2.default)(style, { padding: '16px 16px 16px 40px' });
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

var icon = function icon(overrideStyle) {
  return (0, _combineStyles2.default)(_styles2.default.icon, overrideStyle);
};

var sidebar = function sidebar(overrideStyle) {
  return (0, _combineStyles2.default)(_styles2.default.sidebar, overrideStyle);
};

var footer = function footer(isSidebar, overrideStyle) {
  var style = _styles2.default.footer;

  if (isSidebar) {
    style = (0, _combineStyles2.default)(style, { position: 'initial' });
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

exports.default = {
  container: container,
  overlay: overlay,
  root: root,
  header: header,
  icon: icon,
  sidebar: sidebar,
  footer: footer,
  contentContainer: contentContainer
};
module.exports = exports.default;